import { defineStore } from "pinia";
import { $fetch } from "ofetch";
import { useGetData } from "~/composables/useGetData";
export const useNodiStore = defineStore("nodiStore", {
  state: () => ({
    nodi: [],
    nodiLogstiche: [],
    caricandoNodi: false,
    errorMessage: ""
  }),

  actions: {
    async getNodiOdoo() {
      const { data, getData, loading, messageError } = useGetData();

      this.caricandoNodi = true;
      await getData("/api/nodi");
      this.nodi = data;
      this.errorMessage = messageError;

      await this.getNodiLogsticheOdoo();
      this.caricandoNodi = false;
    },

    async getNodiLogsticheOdoo() {
      const { data, getData, messageError } = useGetData();

      await getData("/api/nodi/nodi_logistiche");

      if (!messageError.value) {
        this.nodiLogstiche = data;
      } else {
        this.errorMessage = messageError;
      }
    }
  }
});
